import React from 'react';
import PropTypes from 'prop-types';
import questionCss from './Questions.scss'
import css from './ShortTextField.scss'
import Icon from 'SF/MaterialIcon';
import Input from './Input';
import { omit } from 'lodash'

export default class ShortTextField extends React.Component {

  getEditableField = (inputProps, questionText) => {
    const { value } = inputProps
    return (
      <Input
          {...omit(inputProps, 'setValue', 'setHasError', 'questionNumber')} 
          type="text" 
          aria-label={questionText} 
          value={value || ''}
          onChange={this.changeHandler} 
        />
    );
  }

  renderEmptyAnswerBlock = () => {
    return (
      <i>No answer provided</i>
    );
  }

  getReadOnlyField = (value) => {
    return (
      <p className={css['short-input-answers']}>{value || this.renderEmptyAnswerBlock()}</p>
    );
  }

  changeHandler = (e) => {
    this.props.setValue(e.target.value)
  }

  render() {
    const { isReadOnly, hasError, questionText, ...rest } = this.props;
    const questionErrorClassName = hasError ? css['error'] : '';
    return (
      <>
        <div className={`${questionErrorClassName}`}>
          {isReadOnly ? this.getReadOnlyField(rest.value) : this.getEditableField(rest, questionText)}
        </div>
        {!isReadOnly && hasError && (
          <div className={questionCss['input-error-message-block']} role="alert">
            <Icon icon="error" /><p>Invalid response</p>
          </div>
        )}
      </>
    );
  }
}

ShortTextField.propTypes = {
  value: PropTypes.string,
  questionText: PropTypes.string,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func
}
